<template>
  <el-dialog title="Добавление поставщика" :visible.sync="isOpen" width="40%">
    <el-form
      v-if="provider"
      ref="formСreateRef"
      :model="provider"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item label="Название" prop="name">
        <el-input v-model="provider.name" />
      </el-form-item>
      <el-form-item label="Коментарий">
        <el-input v-model="provider.comment" type="textarea" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isOpen = false">Закрыть</el-button>
      <el-button type="primary" @click="saveProvider">Сохранить</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { useProviderCreate } from './useProviderCreate';

export default {
  name: 'ProviderCreate',
  setup() {
    const { isOpen, open, provider, saveProvider, rules, formСreateRef } = useProviderCreate();

    return {
      isOpen,
      open,
      provider,
      saveProvider,
      rules,
      formСreateRef,
    };
  },
};
</script>
